import client from "../client";

export interface GetReturnToLossTransactionWithAdminResponse {
  ID?: number;
  Games?: number;
  NameEn?: string;
  HashKey?: string;
  BetRoundID?: Date;
  Amount?: number;
  AfterBetAmount?: number;
  IsSMPointAfterBet?: boolean;
  CurrentMemberBalance?: number;
  Win?: boolean;
  Reject?: boolean;
  Uncalculated?: boolean;
  CreatedAt?: Date;
  UpdateAt?: Date;
  DisplayCreatedAt?: string;
  DisplayUpdatedAt?: string;
  display_amount?: number;
  is_credit_at_snapshot?: boolean;
  payout_type?: "credit" | "diamond";
  status?: string;
  claimed_at?: Date | null;
  transaction_hash_key?: string;
  refund_transaction_hash_key?: string;
}

export default function API(): Promise<
  GetReturnToLossTransactionWithAdminResponse[]
> {
  return client
    .get(`return_to_loss_v2/transactions`)
    .then((response) => response.data);
}
